<template>
  <div class="recordBg">
    <div class="recordHeader">
      <div
        class="return"
        :class="{ active: isReturn }"
        @mousedown="handlePressReturn(true)"
        @mouseup="handlePressReturn(false)"
        @mouseleave="handlePressReturn(false)"
        @touchstart="handlePressReturn(true)"
        @touchend="handlePressReturn(false)"
        @touchcancel="handlePressReturn(false)"
        @click="goReturn"
      ></div>
      <div class="title">测评记录</div>
    </div>

    <div class="summaryCard">
      <div class="summaryLabel">累计测评次数：</div>
      <div class="summaryValue">
        <span class="summaryNumber">{{ totalNum }}</span>
        次
      </div>
    </div>
      <div class="tabelHeader">
        <div class="blockLabel" style="width: 53%; text-align: center;">测评时间</div>
        <!-- <div class="blockLabel">用时</div> -->
        <div class="blockLabel">评分</div>
      </div>
    <div
      class="recordList"
      :class="{ empty: recordList.length === 0 }"
      ref="scrollContainer"
      @scroll.passive="handleScroll"
    >


      <div v-if="recordList.length === 0" class="emptyState">暂无测评记录</div>

      <div
        v-else
        class="recordCard"
        v-for="(item, index) in recordList"
        :key="index"
        :class="{ expanded: expandedIndex === index }"
      >
        <div class="cardSummary">
          <div
            style="
              display: flex;
              align-items: center;
              width: 66%;
              justify-content: space-evenly;
            "
          >
            <div class="blockValue">{{ formatDate(item.createTime) }}</div>
            <div class="line"></div>
            <!-- <div class="blockValue">{{ formatUseTime(item.useTime) }}</div> -->
            <div class="blockScore" style="width: 22%; text-align: center">
              {{ formatScore(item.totalScore) }}
            </div>
            <div class="line"></div>
          </div>

          <button
            class="toggleBtn"
            :class="{ active: expandedIndex === index }"
            @click.stop="toggleExpand(index)"
          >
            {{ expandedIndex === index ? "收起" : "展开" }}
            <div style="margin-left: 5px">
              <van-icon v-if="expandedIndex === index" name="arrow-up" />
              <van-icon v-else name="arrow-down" />
            </div>
          </button>
        </div>

        <transition name="fade">
          <div v-if="expandedIndex === index" class="cardDetail">
            <div v-if="getReportList(item).length > 0" class="abilityList">
              <div
                v-for="(ability, abilityIndex) in getReportList(item)"
                :key="abilityIndex"
                class="abilityItem"
              >
                <div class="abilityHeader">
                  <span class="abilityName">{{ ability.name }}</span>
                  <span class="abilityScore">{{ ability.scoreLabel }}</span>
                </div>
                <div class="progress">
                  <div
                    class="progressBar"
                    :style="{ width: ability.progressWidth }"
                  ></div>
                </div>
              </div>
            </div>
            <div v-else class="emptyReport">暂无维度数据</div>
          </div>
        </transition>
      </div>

      <div v-if="recordList.length > 0" class="listFooter">
        <div class="loading-tip" v-if="loadingMore">加载中...</div>
        <div class="no-more-tip" v-else-if="noMore">没有更多了</div>
      </div>
    </div>
  </div>
</template>
<script>
import { Notify } from "vant"; // 添加这行导入
import { history } from "@/api/index";
export default {
  name: "recordPage",
  data() {
    return {
      query: {
        testId: 0,
        pageNum: 1,
        pageSize: 10,
        deviceCode: "",
      },
      isReturn: false,
      totalNum: 0, // 累计测评次数
      recordList: [],
      loadingMore: false,
      noMore: false,
      expandedIndex: null,
    };
  },
  created() {
    this.history();
  },
  mounted() {},

  methods: {
    handleScroll(e) {
      const el = e.target;
      if (
        !this.loadingMore &&
        !this.noMore &&
        el.scrollHeight - el.scrollTop - el.clientHeight < 30
      ) {
        this.history(); // 快到底了，加载下一页
      }
    },
    goReturn() {
      this.$router.go(-1); // 返回上一页
    },
    handlePressReturn(state) {
      this.isReturn = state;
    },
    // 格式化显示时间
    formatUseTime(totalSeconds) {
      if (totalSeconds === null || totalSeconds === undefined) {
        return "--";
      }
      let duration = Number(totalSeconds) || 0;
      if (duration > 60 * 60 * 24 * 2 * 10) {
        duration = Math.floor(duration / 1000);
      }
      const seconds = Math.floor(duration % 60);
      const minutes = Math.floor((duration / 60) % 60);
      const hours = Math.floor((duration / 3600) % 24);
      const days = Math.floor(duration / 86400);

      if (duration < 3600) {
        // 小于 1 小时 → 分秒
        return `${minutes.toString().padStart(2, "0")}分 ${seconds
          .toString()
          .padStart(2, "0")}秒`;
      } else if (duration < 86400) {
        // 小于 1 天 → 时分秒
        return `${hours.toString().padStart(2, "0")}时 ${minutes
          .toString()
          .padStart(2, "0")}分 ${seconds.toString().padStart(2, "0")}秒`;
      } else {
        // 大于等于 1 天 → 天时分秒
        return `${days}天 ${hours.toString().padStart(2, "0")}时 ${minutes
          .toString()
          .padStart(2, "0")}分 ${seconds.toString().padStart(2, "0")}秒`;
      }
    },
    formatDate(dateString) {
      if (!dateString) return "--";
      const date = new Date(dateString.replace(/-/g, "/"));
      if (Number.isNaN(date.getTime())) {
        return dateString;
      }
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hour = date.getHours().toString().padStart(2, "0");
      const minute = date.getMinutes().toString().padStart(2, "0");
      return `${year}/${month}/${day} ${hour}:${minute}`;
    },
formatScore(score) {
  if (score === null || score === undefined || score === "") {
    return "--";
  }
  const value = Number(score);
  if (Number.isNaN(value)) return "--";

  // ✅ 修复浮点误差
  const displayScore = Math.round(value * 100); // 保留整数分数
  return `${displayScore}分`;
},

    getReportList(item) {
      if (!item) return [];
      const raw = item.report;
      if (!raw) return [];
      let list = [];
      try {
        list = Array.isArray(raw) ? raw : JSON.parse(raw);
        console.log(list, "list");
      } catch (error) {
        console.warn("报告解析失败", error);
        return [];
      }
      return list.filter(Boolean).map((record, index) => {
        const score = this.resolveAbilityScore(record);
        return {
          name: record.name || `维度${index + 1}`,
          score,
          scoreLabel: `${score}分`,
          progressWidth: `${Math.min(Math.max(score, 0), 100)}%`,
        };
      });
    },
    resolveAbilityScore(record) {
      if (!record || typeof record !== "object") return 0;
      if (record.score !== undefined && record.score !== null) {
        const value = Number(record.score);
        if (!Number.isNaN(value)) return Math.round(value);
      }
      if (record.ratio !== undefined && record.ratio !== null) {
        const value = Number(record.ratio) * 100;
        if (!Number.isNaN(value)) return Math.round(value);
      }
      if (
        record.valid !== undefined &&
        record.total !== undefined &&
        Number(record.total) !== 0
      ) {
        const value = (Number(record.valid) / Number(record.total)) * 100;
        if (!Number.isNaN(value)) return Math.round(value);
      }
      return 0;
    },
    toggleExpand(index) {
      this.expandedIndex = this.expandedIndex === index ? -1 : index;
    },

    async history() {
      if (this.loadingMore || this.noMore) return;

      this.loadingMore = true;

      // 获取设备信息
      const deviceCode = this.$store.getters.getDeviceCode;
      this.query.deviceCode = deviceCode;
      const testId = this.$store.getters.getTestId;
      this.query.testId = testId;

      try {
        const res = await history(this.query);
        if (res.data.code === 200) {
          const { rows = [], total = 0 } = res.data.data || {};
          const newList = Array.isArray(rows) ? rows : [];
          if (this.query.pageNum === 1) {
            this.recordList = [];
            this.noMore = false;
          }
          this.recordList.push(...newList);
          this.totalNum = total;
          if (
            this.recordList.length >= total ||
            newList.length < this.query.pageSize
          ) {
            this.noMore = true;
          } else {
            this.query.pageNum += 1;
          }
          if (this.recordList.length && this.expandedIndex === -1) {
            this.expandedIndex = 0;
          }
        } else {
          Notify({
            message: res.data.msg,
            duration: 1000,
          });
        }
      } finally {
        this.loadingMore = false;
      }
    },
  },
};
</script>

<style scoped lang="less">
.recordBg {
  width: 100%;
  height: 100vh;
  box-sizing: border-box;

  background: url("@/assets/recordBg.png") no-repeat center / 100% 100%;
  font-family: Alibaba-PuHuiTi-Regular, "Microsoft Yahei", sans-serif;
  display: flex;
  flex-direction: column;
}
.recordHeader {
  display: flex;
  align-items: center;
  // margin-bottom: 24px;
  padding: 20px 40px 40px;
  .return {
    width: 80px;
    height: 80px;
    background: url("@/assets/return.png") no-repeat center / 100% 100%;
    margin-right: 20px;
    cursor: pointer;
    transition: transform 0.2s ease;
  }
  .return.active {
    background: url("@/assets/returnOver.png") no-repeat center / 100% 100%;
    transform: scale(0.96);
  }
  .title {
    flex: 1;
    text-align: center;
    font-size: 45px;
    font-weight: 700;
    color: #ffffff;
    text-shadow: 0 4px 12px rgba(39, 77, 119, 0.15);
    margin-right: 80px;
  }
}
.summaryCard {
  margin: 20px 40px 40px;
  padding: 28px 36px;
  border-radius: 122.5px;
  box-shadow: inset 0px 10px 10px 0px rgba(118, 187, 255, 0.43);
  background: rgba(255, 255, 255, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  color: #000000;
  font-size: 40px;
  font-weight: 700;
}
.summaryValue {
  display: flex;
  align-items: baseline;
}
.summaryNumber {
  font-weight: 700;
  color: #f5683a;
  margin-right: 12px;
}
.recordList {
  flex: 1;

  overflow-y: auto;
  /* 隐藏滚动条 - Webkit浏览器 (Chrome, Safari, Edge) */
  &::-webkit-scrollbar {
    display: none;
  }

  /* 隐藏滚动条 - Firefox */
  scrollbar-width: none;

  /* 隐藏滚动条 - IE/Edge */
  -ms-overflow-style: none;
}
.recordList.empty {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  color: #6f7f99;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 24px;
  box-shadow: inset 0 0 0 1px rgba(215, 225, 241, 0.8);
}
.recordCard {
  background: #ffffff;
  // padding-top: 30px;
  border-bottom: 1px solid #e1e9f5;
  box-shadow: 0 16px 36px rgba(78, 118, 186, 0.18);
  transition: box-shadow 0.2s ease;
}
.recordCard.expanded {
  box-shadow: 0 18px 40px rgba(70, 110, 186, 0.22);
}
.tabelHeader {
  display: flex;
  align-items: center;
  padding: 20px 0px;
  // justify-content: space-around;
  background: linear-gradient(
    180deg,
    rgba(74, 177, 255, 1),
    rgba(124, 199, 255, 1) 100%
  );
}
.blockLabel {
  font-size: 35px;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: 1px;
}
.cardSummary {
  display: flex;
  align-items: center;
  font-size: 35px;
  flex-wrap: wrap;
  padding: 20px 0px;
  justify-content: space-around;
}
.summaryBlock {
  flex: 1;
  min-width: 160px;
}

.blockValue {
  display: flex;
  align-items: center;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  word-break: break-all;
}
.line {
  display: inline-block;
  width: 2px;
  height: 30px;
  background: #d6e1f3;
}
.blockScore {
  font-weight: 700;
  color: #ff6a21;
}
.toggleBtn {
  display: flex;
  padding: 5px 15px;
  border: none;
  border-radius: 10px;
  background: linear-gradient(90deg, #ffa14a 0%, #ff6b2c 100%);
  color: #ffffff;
  font-weight: 400;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 8px 18px rgba(255, 118, 58, 0.35);
}
.toggleBtn.active {
  background: linear-gradient(90deg, #5f8cff 0%, #3562ff 100%);
  box-shadow: 0 8px 20px rgba(72, 114, 255, 0.35);
}
.toggleBtn:active {
  transform: scale(0.96);
}
.cardDetail {
  padding: 30px 60px;
  // border-top: 1px dashed #d6e1f3;
  background: rgba(227, 235, 255, 1);
}
.abilityList {
  display: flex;
  flex-direction: column;
  gap: 22px;
}
.abilityItem {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-bottom: 10px;
}
.abilityHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 35px;
  color: rgba(51, 51, 51, 1);
  font-weight: 400;
}
.abilityScore {
  // color: #ff6a21;
  // font-size: 30px;
}
.progress {
  width: 100%;
  height: 18px;
  border-radius: 10px;
  background: #e9effc;
  overflow: hidden;
}
.progressBar {
  height: 100%;
  background: linear-gradient(
    270deg,
    rgba(71, 135, 255, 1),
    rgba(81, 223, 255, 1) 100%
  );
  border-radius: 10px;
  transition: width 0.3s ease;
}
.emptyReport {
  text-align: center;
  color: #8997b2;
  font-size: 28px;
  padding: 20px 0;
}
.listFooter {
  text-align: center;
  font-size: 28px;
  color: #7c8cac;
  padding: 10px 0 20px;
}
.loading-tip,
.no-more-tip {
  color: inherit;
}
.recordList::-webkit-scrollbar {
  width: 8px;
}
.recordList::-webkit-scrollbar-thumb {
  background: rgba(123, 153, 210, 0.5);
  border-radius: 4px;
}
.recordList::-webkit-scrollbar-track {
  background: transparent;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
